import React, { useContext, useState } from "react";
import { PropTypes } from "prop-types";

import CustomModal from "../../../react_utils/modals/CustomModal";

import CustomForm from "../../../react_utils/form/CustomForm";

import ModalFooter from "../../../react_utils/modals/ModalFooter";
import { MessagingContext } from "../../MessagingContext";
import useClientLocation from "../../../shared/hooks/client/useClientLocation";
import { AuthContext } from "../../../shared/contexts/AuthContext";

export default function ClientLocationFormModal({
  client,
  resetParent,
  modalProps = {},
  location = null,
}) {
  const { apiClient } = useContext(AuthContext);
  const { showMessage } = useContext(MessagingContext);
  const [isFocused, setIsFocused] = useState(false);

  const { userForm, locationAssignmentForm, onSubmit, createUser } =
    useClientLocation(
      client,
      resetParent,
      location,
      apiClient,
      showMessage,
      isFocused,
    );

  const onToggle = (isOpen) => {
    setIsFocused(isOpen);
    modalProps.onToggle?.(isOpen);
  };

  const getFooter = (toggle) => {
    return (
      <ModalFooter
        buttons={[{ label: "Zuordnen", onClick: () => onSubmit(toggle) }]}
      />
    );
  };

  return (
    <>
      <CustomModal
        title="Gerät zuordnen"
        getFooter={getFooter}
        {...modalProps}
        onToggle={onToggle}
      >
        <CustomForm
          template={locationAssignmentForm.template}
          form={locationAssignmentForm.form}
          setForm={locationAssignmentForm.setForm}
          showMissingFields={locationAssignmentForm.showMissingFields}
        />
        {/* <Checkbox
          label={"Kundenkonto erstellen"}
          onChange={(checked) => setCreateUser(checked)}
          checked={createUser}
        /> */}{" "}
        {/* Checkbox to create user is removed */}
        {createUser && (
          <CustomForm
            template={userForm.template}
            form={userForm.form}
            setForm={userForm.setForm}
            showMissingFields={userForm.showMissingFields}
          />
        )}
      </CustomModal>
    </>
  );
}

ClientLocationFormModal.propTypes = {
  client: PropTypes.object,
  modalProps: PropTypes.object,
  resetParent: PropTypes.func,
  location: PropTypes.object,
};
